import { registerRequest, registerSuccess, registerError } from './actions';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { RegisterActionTypes } from './types';
import registerApi from '../../api/registerApi';
import { AxiosResponse } from 'axios';
import { Authentication } from '../../model/authentication';

function* handleRegister(action: ReturnType<typeof registerRequest>) {
    try {
        const result: AxiosResponse<Authentication> = yield call(registerApi.registerFree, action.payload);

        if (result.status !== 201) {
            const errorMessage: string = result.status === 401 ? 'Cannot register this user' : 'An unknown error occured.';
            yield put(registerError(errorMessage));
            return;
        } else {
            yield put(registerSuccess());
            return;
        }
    } catch (err) {
        yield put(registerError('Error'));
        if (err instanceof Error && err.stack) {
            yield put(registerError(err.stack));
        } else {
            yield put(registerError('An unknown error occured.'));
        }
    }
}

function* watchRegisterRequest() {
    yield takeEvery(RegisterActionTypes.REGISTER_REQUEST, handleRegister);
}

function* registerSaga() {
    yield all([fork(watchRegisterRequest)]);
}

export default registerSaga;
